<div class="table">
  <div class="blockheader">{{'Object settings'|translate}}</div>
  <div class="datablock">
    <div class="inputgroup">
      <label>{{'Name'|translate}}<b class="question">?<i>{{'Object name'|translate}}</i></b></label>
      <input  type="text" [(ngModel)]="Object.Name" />
    </div>
    <div class="inputgroup">
      <label>{{'Description'|translate}}<b class="question">?<i>{{'Object additional info'|translate}}</i></b></label>
      <input  type="text" [(ngModel)]="Object.Comment" />
    </div>
    <div class="inputgroup">
      <label>{{'Device ID'|translate}}<b class="question">?<i>{{'Device unique identifier or IMEI'|translate}}</i></b></label>
      <input type="text"  [(ngModel)]="Object.IMEI" [readonly]="Object.Id !=0 && !canEditImei" (input)="onIMEIInput(($any($event.target).value))" />
    </div>
    <!--<div class="inputgroup">
      <label>{{'Inventory №'|translate}}</label>
      <input type="text" [(ngModel)]="Object.InventoryNumber" />
    </div>-->
    <div class="inputgroup">
      <label>{{'Phone №'|translate}}</label>
      <input [readOnly]="!canEditTrackers" type="text" [(ngModel)]="Object.Phone" />
    </div>
    <div class="inputgroup">
      <label>{{'Phone №'|translate}}</label>
      <input [readOnly]="!canEditTrackers" type="text" [(ngModel)]="Object.Phone1" />
    </div>
    <div class="inputgroup">
      <label>{{'Inventory number'|translate}}</label>
      <input [readOnly]="!canEditTrackers" type="text" [(ngModel)]="Object.InventoryNumber" />
    </div>
    <div class="inputgroup">
      <label>{{'State number'|translate}}</label>
      <input [readOnly]="!canEditTrackers" type="text" [(ngModel)]="Object.StateNumber" />
    </div>
    <div class="inputgroup">
      <label>{{'Device model'|translate}}<b class="question">?<i>{{'Device model'|translate}}</i></b></label>
      <div>
        <select [disabled]="!canEditTrackers" title="{{'Device model'|translate}}" [(ngModel)]="Object.DeviceType" style="margin: 0 5px 5px 0; width: 100%;">
          <option *ngFor="let devModel of models" value="{{devModel.Name}}" [selected]="Object.DeviceType == devModel.Name">{{devModel.Name | translate}}</option>
        </select>
      </div>
    </div>

    <div class="inputgroup" *ngIf="Object.CreateDate">
      <label>{{'Created at'|translate}}</label>
      <label>{{Object.CreateDate | date: 'dd.MM.yyyy'}}</label>

    </div>

    <div class="inputgroup">
      <label>{{'Status'|translate}}</label>
        <select [disabled]="!canEditTrackers" class="status-select" title="{{'Status'|translate}}" [(ngModel)]="Object.Status">
          <option [ngValue]="ObjectStatus.Blocked" [selected]="Object.Status === ObjectStatus.Blocked">{{'Blocked' | translate}}</option>
          <option [ngValue]="ObjectStatus.Active" [selected]="Object.Status === ObjectStatus.Active">{{'Active' | translate}}</option>
          <option [ngValue]="ObjectStatus.NotInstalled" [selected]="Object.Status === ObjectStatus.NotInstalled">{{'Not installed' | translate}}</option>
          <option [ngValue]="ObjectStatus.Broken" [selected]="Object.Status === ObjectStatus.Broken">{{'Broken' | translate}}</option>
          <option [ngValue]="ObjectStatus.OnService" [selected]="Object.Status === ObjectStatus.OnService">{{'In service' | translate}}</option>
          <option [ngValue]="ObjectStatus.Deleted" [selected]="Object.Status === ObjectStatus.Deleted">{{'Deleted' | translate}}</option>
        </select>
    </div>

<!--    <div class="inputgroup">
      <label>{{'Type'|translate}} </label>
      <select title="{{ 'Type' | translate }}" (change)="onTypeChange($any($event.target).value)">
        <option value="">{{'None'|translate}}</option>
        <option value="CARTRACKER" [selected]="Object.HasFlag('CARTRACKER')">{{'Car tracker'|translate}}</option>
        <option value="PERSONAL" [selected]="Object.HasFlag('PERSONAL')">{{'Personal tracker'|translate}}</option>
        <option value="FUEL" [selected]="Object.HasFlag('FUEL')">{{'Gas station'|translate}}</option>
        <option value="TANK" [selected]="Object.HasFlag('TANK')">{{'Tank'|translate}}</option>
        <option value="GENERATOR" [selected]="Object.HasFlag('GENERATOR')">{{'Generator'|translate}}</option>
        <option value="SEAL" [selected]="Object.HasFlag('SEAL')">{{'Electronic seal'|translate}}</option>
      </select>
    </div>-->
    <div class="inputgroup">
      <label>{{'Static'|translate}}</label>
      <input [readOnly]="!canEditTrackers" type="checkbox" [checked]="Object.HasFlag('STATIC')" (change)="onStaticChange(($any($event.target).checked))" />
    </div>
    <div class="inputgroup" *ngIf="Object.HasFlag('STATIC')">
      <label>{{'Coordinates'|translate}}</label>
      <input [readOnly]="!canEditTrackers" type="text" [ngModel]="(this.Object.DefLat || 0.0).toFixed(5) + ' ' + (this.Object.DefLng || 0.0).toFixed(5)" [readOnly]="true" (click)="selectPoint()" />
    </div>
    <div class="inputgroup" *ngIf="Object.HasFlag('STATIC')">
      <label>{{'Address'|translate}}</label>
      <input [readOnly]="!canEditTrackers" type="text" [(ngModel)]="Object.Address" />
    </div>
    <div class="inputgroup">
      <label>{{'Timezone'|translate}}</label>
      <select [disabled]="!canEditTrackers" *ngIf="showTZ" title="{{'Timezone'|translate}}" [(ngModel)]="Object.TimeZone">
        <option *ngFor="let timezone of timezones" value="{{timezone.Name}}"
                [selected]="Object.TimeZone === timezone.Name">
          {{timezone.DisplayName}}
        </option>
      </select>
      <div (click)="showTZ=true" *ngIf="!showTZ" class="clickable">{{'Is the device using a non-standard time zone?'|translate}}</div>
    </div>
  </div>

  <div class="blockheader">{{'Personalization'|translate}}</div>
  <div class="datablock">
    <div class="inputgroup" style="z-index: 14;">
      <label>
        {{'Track color'|translate}}
      </label>
      <app-color-selector (onColorSelected)="onColorSelected($event)" [color]="Object.TrackColor"></app-color-selector>
    </div>
    <div class="inputgroup" style="z-index: 13;">
      <label>{{'Icon'|translate}} </label>
      <app-icon-selector [icons]="Icons" [selectedIcon]="Object.IconId" (onIconSelected)="onIconChange($event)"></app-icon-selector>
    </div>
  </div>

  <app-base-group-mgmt-component [Title]="'Commands'"
                                 [Objects]="Object.CommandIds"
                                 [readonly]="!canEditTrackers"
                                 [filtered]="Commands"
                                 [groups]="Commands"
                                 style="z-index: 1;"
  >
    <ng-template let-item>
      <td>{{item.Name}}</td>
    </ng-template>
  </app-base-group-mgmt-component>

  <app-base-group-mgmt-component [readonly]="false" [Title]="'Groups'" [Objects]="Object.GroupIds" [groups]="Groups" style="z-index: 1;">
    <ng-template let-item>
      <td>{{item.Name}}</td>
    </ng-template>
  </app-base-group-mgmt-component>
</div>

<template #mgmtDialog></template>
